import { Location } from '@angular/common';
import { Component, ElementRef, EventEmitter, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { BaseComponent } from '../../core/components';
import { IPagedResults } from '../../core/interfaces';
import { EmailTemplateModel } from '../../models';
import { EmailService } from '../../services';
@Component({
    selector: 'app-email-template-list',
    templateUrl: './email-template-list.component.html',
    styleUrls: ['../layout/layout.component.scss']
})
export class EmailTemplateListComponent extends BaseComponent implements OnInit {
    @Output() emailTempateListView = new EventEmitter();
    public showSpinner: boolean = false;
    public totalItems: number = 10;
    public model: any;
    public isSystem: any;
    constructor(
        private elem: ElementRef,
        private toastr: ToastsManager,
        private emailService: EmailService,
        private route: ActivatedRoute,
        private router: Router,
        private location: Location) {
        super(router);
    }

    packageData: Subject<any> = new Subject<any[]>();
    public ngOnInit(): void {
        this.model = new EmailTemplateModel();
        this.loadData();
    }

    public loadData(id?: number, moduleId?: number): void {
        id = !id ? 1 : id;
        moduleId = !moduleId ? 0 : moduleId;
        this.showSpinner = true;
        this.model = new EmailTemplateModel();
        this.model.LanguageId = id;
        this.emailService.getAllEmailTemplateList(id, moduleId)
            .catch((err: any) => {
                return Observable.throw(err);
            })
            .finally(() => {
                setTimeout(() => {
                    this.showSpinner = false;
                }, 1000);
            })
            .subscribe((response: IPagedResults<any>) => {
                let data = response.Data;

                this.packageData.next(data);
                this.totalItems = response.Data.length;
            });
    }

    insertAtCursor(myField, myValue) {
        if (myField.selectionStart || myField.selectionStart == '0') {
            myField.focus();
            //Here we get the start and end points of the
            //selection. Then we create substrings up to the
            //start of the selection and from the end point
            //of the selection to the end of the field value.
            //Then we concatenate the first substring, myValue,
            //and the second substring to get the new value.
            var startPos = myField.selectionStart;
            var endPos = myField.selectionEnd;
            myField.value = myField.value.substring(0, startPos) + myValue + myField.value.substring(endPos, myField.value.length);
            myField.setSelectionRange(endPos + myValue.length, endPos + myValue.length);
        } else {
            myField.value += myValue;
        }
        this.model.Body = myField.value;
    }

    addVariable(item: any, text: string) {

        let field = this.elem.nativeElement.querySelector('#textarea-' + item.Id);
        this.insertAtCursor(field, text + " ");

        // item.Body = item.Body + text;
    }

    public toggleEditor(e, item) {
        let viewElement = this.elem.nativeElement.querySelector('#view-' + item.Id);
        let element = this.elem.nativeElement.querySelector('#editor-' + item.Id);
        // if(e.checked) {
        element.style.display = '';
        viewElement.style.display = 'none';
        //subject.innerHTML = '';
        //body.innerHTML = '';
        this.model = item;

        if (item.IsEdit == false || item.IsEdit == undefined) {
            item.IsEdit = true;
        } else {
            item.IsEdit = false;
        }
        // }
        // else {
        //     element.style.display = 'none';
        //     viewElement.style.display = 'block';

        //     //subject.innerHTML = item.Subject;
        //     //body.innerHTML = item.Body;
        // }
    }

    public emailTemplateViewMode(id) {
        let element = this.elem.nativeElement.querySelector('#editor-' + id);
        element.style.display = 'none';
    }

    public closeEmailEditor(id) {
        this.emailTemplateViewMode(id)
        this.model = new EmailTemplateModel();
        this.emailTempateListView.emit();
    }

    public toggleIsSystem(e, item) {
        this.model.IsSystem = e.checked;
        this.isSystem = e.checked;
        this.toggleEditor(e, item);
    }

    public saveChanges(item) {
        this.showSpinner = true;
        this.model.IsSystem = this.isSystem;
        this.emailService.saveEmailTemplate(this.model)
            .catch((err: any) => {
                this.toastr.error(err, 'Error');
                return Observable.throw(err);
            }).finally(() => {
                this.showSpinner = false;
            })
            .subscribe((response) => {
                if (response.ErrorCode) {
                    this.toastr.error(response.Message, "Error");
                }
                this.closeEmailEditor(this.model.Id);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/email/email-template-list.component.ts